<template>
  <div>
    <validation-observer ref="form">
      <form novalidate @submit.prevent="saveReport">
        <mdb-modal side position="right" fullHeight direction="right" :show="modal" @close="close">
          <mdb-modal-header>
              <mdb-modal-title class="h4">Pflegebericht erstellen</mdb-modal-title>
          </mdb-modal-header>
            <mdb-modal-body class="example-card scrollbar-blue thin">
              <validation-provider
                name="Datum"
                rules="required"
                v-slot="{ errors, valid, validated }"
                slim
              >
                <mdb-date-picker
                  v-model="datum"
                  disabledFuture
                  label="Datum"
                  name="Datum"
                  :option="optionDatePicker"
                  :customValidation="validated"
                  :isValid="valid"
                  :invalidFeedback="errors[0]"
                  validFeedback="sieht gut aus"
                  outline
                  @getValue="getPickersValue"
                />
              </validation-provider>
              <validation-provider
                name="Uhrzeit"
                rules="required"
                v-slot="{ errors, valid, invalid }"
                slim
              >
                <mdb-time-picker
                  id="uhrzeit"
                  v-model="uhrzeit"
                  label="Uhrzeit"
                  name="Uhrzeit"
                  :hours-format="24"
                  class="mb-0"
                  outline
                  :done-label="optionTimePicker.done"
                  :closeLabel="optionTimePicker.cancel"
                  :clearLabel="optionTimePicker.clear"
                  @getValue="verifyValue"
                />
                <span v-if="valid" class="valid-feedback d-block">sieht gut aus</span>
                <span v-if="invalid" class="invalid-feedback d-block">{{ errors[0] }}</span>
              </validation-provider>
              <validation-provider
                name="Beschreibung"
                rules="required"
                v-slot="{ errors, valid, validated }"
                slim
              >
                <mdb-input
                  v-model="form.Text"
                  type="textarea"
                  :rows="5"
                  label="Beschreibung"
                  name="Beschreibung"
                  :customValidation="validated"
                  :isValid="valid"
                  :invalidFeedback="errors[0]"
                  validFeedback="sieht gut aus"
                  outline
                />
              </validation-provider>
              <mdb-switch
                v-model="form.Wichtig"
                color="primary"
                offLabel=""
                onLabel="Wichtig?"/>
            </mdb-modal-body>
            <mdb-modal-footer>
                <mdb-btn color="grey lighten-1" @click.native="close">Zurück</mdb-btn>
                <mdb-btn
                  color="primary"
                  :disabled="loading"
                  type="submit"
                >
                  <template v-if="!loading">
                    Erstellen <mdb-icon icon="save" />
                  </template>
                  <template v-else>
                    <span
                      class="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Verladung
                  </template>
                </mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>
      </form>
    </validation-observer>
  </div>
</template>

<script>
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbDatePicker,
    mdbTimePicker,
    mdbInput,
    mdbSwitch,
    mdbIcon
  } from 'mdbvue';
  import utils from '@/mixins/Utils'

  export default {
    name: 'AddPatientReportModal',
    mixins: [utils()],

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbDatePicker,
      mdbTimePicker,
      mdbInput,
      mdbSwitch,
      mdbIcon
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        modal: false,
        loading: false,
        uhrzeit: new Date().getHours() + ":" + new Date().getMinutes(),
        datum: new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        form: {
          Datum: '',
          Text: '',
          Wichtig: false,
          AenderungVon: '',
          AenderungAm: '',
          GastId: ''
        },
        defaultForm: {
          Datum: '',
          Text: '',
          Wichtig: false,
          AenderungVon: '',
          AenderungAm: '',
          GastId: ''
        }
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
    },

    methods: {
      close () {
        this.$refs.form.reset()
        this.datum = new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        this.uhrzeit = new Date().getHours() + ":" + new Date().getMinutes(),
        this.form = Object.assign({}, this.defaultForm)
        this.schichtOptions.find(option => {
          option.selected = option.index === 0 ? true : false
        })
        this.$emit('close')
      },

      save() {
        this.close()
        this.$emit('save')
      },

      getPickersValue (value) {
        if(value) {
          this.datum = value
        }
      },

      verifyValue() {
        const time = document.getElementById('uhrzeit')
        if(time) {
          if(this.uhrzeit === '' || this.uhrzeit === undefined) {
            time.classList.add('is-invalid')
            time.classList.remove('is-valid')
          }else {
            time.classList.add('is-valid')
            time.classList.remove('is-invalid')
          }
        }
      },

      saveReport() {
        // time picker validation check
        this.verifyValue()

        this.form.Datum = this.formatDateY(this.datum)
        var userDate= new Date(this.form.Datum + ' ' +this.uhrzeit)
        this.form.Datum = this.serverDateFormat(userDate)
        this.form.AenderungAm =  this.serverDateFormat(userDate)
        this.form.AenderungVon = this.loginUser.username
        this.form.GastId = this.roomID

        this.loading = true
        this.$refs.form.validate().then(success => {
          if (!success) {
            this.loading = false
            return
          }

          this.$http.post('Dashboard', this.form)
          .then(res => {
            if(!res.data) {
              this.$notify.success({message: 'Erstellen Sie erfolgreich einen Wartungsbericht', position: 'top right', closeButton: false, timeOut: 5000})
              this.save()
            }else {
              this.$notify.error({message: 'Gescheitert!! Erstellen Sie einen Wartungsbericht', position: 'top right', closeButton: false, timeOut: 5000})
            }
          })
          .finally(() => {
            this.loading = false
          })
        });
      }
    }
  }
</script>
